import React from 'react';

const AuthzPermissionFormModal = React.lazy(() => import('../components/FormModal'));
const authzPermissionModalRegistry = {
    core_authzPermissionId: AuthzPermissionFormModal
};
export default authzPermissionModalRegistry;
